import React, { useState, useEffect, useContext } from 'react'
import { collection, query, orderBy, onSnapshot } from "firebase/firestore"
import { app, database, storage } from '../../../firebaseConfig'
import {Button, LinearProgress } from '@mui/material'
import AddRegion from './AddRegion'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridActionsCellItem, GridToolbar, frFR } from '@mui/x-data-grid'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditRegion from './EditRegion'
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';


function Region() {
    const {user}=useContext(AuthContext)
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [regions, setRegions] = useState([])
    const [region, setRegion] = useState(null)
    const [loadingData, setLoadingData] = useState(true)
    const columns = [
        {
            field: 'nom',
            headerName: 'Nom',
            minWidth: 800,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 50,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                return [
                    <GridActionsCellItem icon={<EditIcon />}
                        label="Edit"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            setShowEditModal(true)
                            setRegion(row)

                        }} />
                ]
            }
        }
    ]
    useEffect(() => {
        setLoadingData(true)
        const q = query(collection(database, 'region'), orderBy('nom', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setRegions(querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })))

        })
        setLoadingData(false)
    }, [])

    if(user.type !='Admin'){
        return <AccessDinied/>
    }

    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <Button variant="contained" size='small' onClick={() => { setShowAddModal(true) }} startIcon={<AddCircleOutlineIcon />}>
                Ajouter
            </Button>
            <div style={{ width: '100%', height: 450 }}>
                <DataGrid rowSelection={false}
                    columns={columns}
                    rows={regions}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10, 25, 100]}
                    sx={{ marginTop: 2 }}
                    slots={{
                        toolbar: GridToolbar,
                        loadingOverlay: LinearProgress,
                    }}
                    loading={loadingData}
                    localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                />
            </div>

            {showAddModal &&
                <AddRegion onClose={() => setShowAddModal(false)} open={showAddModal} list={regions} />
            }
            {showEditModal &&
                <EditRegion onClose={() => setShowEditModal(false)} open={showEditModal} data={region} list={regions} />
            }
        </div>
    )
}

export default Region